import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuardFxn } from './core/guards/auth.guard';
import { profileResolver } from './core/resolver/profile.resolver';
import { InvoicePayoutComponent } from './shared/components/invoice-payout/invoice-payout.component';
import { PaymentLinkExpiredComponent } from './shared/components/payment-link-expired/payment-link-expired.component';
// multitenanat to single tenant
// import { NotVerifiedComponent } from './core/common_components/not-verified/not-verified.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthComponent,
    resolve: {
      profile: profileResolver
    },
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth-route').then((m) => m.routes)
      }
    ]
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardFxn],
    resolve: {
      profile: profileResolver
    },
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/after-login-page/pages-route').then((m) => m.routes)
      }
    ]
  },
  {
    path: 'admin/invoice-payout',
    component: InvoicePayoutComponent
  },
  {
    // Public, unauthenticated — the backend redirects here when a shared
    // course-purchase payment link is invalid or has passed its TTL. The
    // payer (parent/sponsor) never logs in, so this must sit outside
    // AuthGuardFxn.
    path: 'payment-link-expired',
    component: PaymentLinkExpiredComponent
  },
  // multitenanat to single tenant
  // {
  //   path: 'not-verified',
  //   component: NotVerifiedComponent
  // }
];

RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled'
});